export const API_BASE_URL = process.env.REACT_APP_API_URL;

/** localStorage key for JWT (sent as Authorization: Bearer on API calls) */
export const API_TOKEN_KEY = 'api_token';
/** localStorage key for current admin user data */
export const ADMIN_DATA_KEY = 'admin_data';
/** Stable browser install id sent to POST /admin/devices/register */
export const DEVICE_ID_KEY = 'admin_device_id';
/** Last FCM token from Firebase getToken() */
export const FCM_TOKEN_KEY = 'admin_fcm_token';
